import { defineStore } from 'pinia';
import { i18n } from '@/i18n';
import { v4 as uuidv4 } from 'uuid';

export interface IAlert {
    id: string;
    isError?: boolean;
    isSuccess?: boolean;
    title?: string;
    content?: string;
    icon?: string;
}

export interface AlertStoreState {
    alert?: IAlert;
    toasts?: IAlert[];
}

export const useAlertStore = defineStore('alert-store', {
    state: (): AlertStoreState => ({
        alert: null,
        toasts: []
    }),
    getters: {},
    actions: {
        handleException(title: string, error: any, isToast = true) {
            const content = parseException(error);
            this.setError(title, content, isToast);
        },
        setError(title: string, content: string = '', isToast = true) {
            const alert = {
                id: uuidv4(),
                isError: true,
                icon: 'alert-triangle',
                title: title,
                content: content
            };

            this.setAlert(alert, isToast);
        },
        setSuccess(title: string, content: string = '', isToast = true) {
            const alert = {
                id: uuidv4(),
                isSuccess: true,
                icon: 'check-circle',
                title: title,
                content: content
            };

            this.setAlert(alert, isToast);
        },
        setAlert(alert: IAlert, isToast = true) {
            if (isToast) {
                const duplicate = this.toasts.find((x) => x.title === alert.title && x.content === alert.content);
                this.toasts.push(alert);
                if (duplicate) {
                    this.clearToast(duplicate.id);
                }
                setTimeout(() => {
                    this.clearToast(alert.id);
                }, 5000);
            } else {
                this.alert = alert;
            }
        },
        clearToast(id: string) {
            this.toasts = this.toasts.filter((x) => x.id !== id);
        },
        clearAlert() {
            this.alert = null;
        }
    }
});

export function parseException(error: any): string {
    if (error?.errors && error.errors.length > 0) {
        return error.errors[0].detail;
    }

    if (error?.title && error?.status) {
        return error.title;
    }

    return i18n.global.t('errors.general');
}
